// Password sharing templates for WhatsApp/Email

export const generatePasswordMessage = (username, password, role, name) => {
    const roleDisplay = role === 'manager' ? 'Manager' : 'Sub Manager';

    return `🔐 *EcoHomely Admin Panel Access*

Hello ${name},

Your admin panel access has been created:

👤 *Username:* ${username}
🔑 *Password:* ${password}
👔 *Role:* ${roleDisplay}

🌐 *Login URL:* [Your admin panel URL]

📱 *Instructions:*
1. Open the admin panel URL
2. Enter your username and password
3. You'll have access based on your role

⚠️ *Important:*
- Keep your credentials secure
- Do not share with unauthorized persons
- Contact admin if you need help

Best regards,
EcoHomely Admin Team`;
};

export const generateEmailTemplate = (username, password, role, name) => {
    const roleDisplay = role === 'manager' ? 'Manager' : 'Sub Manager';

    return {
        subject: `EcoHomely Admin Panel Access - ${name}`,
        body: `
Dear ${name},

Your admin panel access has been created successfully.

Login Details:
- Username: ${username}
- Password: ${password}
- Role: ${roleDisplay}

Please log in using these credentials and change your password if needed.

If you have any questions or need assistance, please contact the admin team.

Best regards,
EcoHomely Admin Team
    `.trim()
    };
};

// Copy to clipboard function
export const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (err) {
        console.error('Failed to copy text: ', err);
        return false;
    }
};
